import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.svg`
  .fill {
    fill: ${(props) => props.theme.colors.mediumGrey};
  }
`

export const SettingsIcon: React.FC<{ className?: string }> = (props) => (
  <Wrapper
    className={`settingsIcon ${props.className}`}
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="fill"
      d="M7.009 11.2A4.2 4.2 0 1111.21 7a4.205 4.205 0 01-4.2 4.2m6.4-5.049l-.242-.021a.828.828 0 01-.732-.5 5.592 5.592 0 00-.62-1.5.825.825 0 01.16-.879l.155-.186c.34-.388.2-.631-.067-.9l-.225-.225c-.272-.273-.516-.408-.9-.068l-.186.156a.822.822 0 01-.906.148 5.573 5.573 0 00-1.4-.583.815.815 0 01-.571-.758L7.854.593C7.812.077 7.545 0 7.16 0h-.319c-.385 0-.653.077-.687.592l-.022.242a.809.809 0 01-.6.767 5.56 5.56 0 00-1.3.544.042.042 0 000-.008.809.809 0 01-.969-.114l-.196-.153c-.388-.34-.632-.2-.9.068l-.225.224c-.272.273-.408.517-.069.9l.157.186a.809.809 0 01.114.97l.011.006a5.525 5.525 0 00-.542 1.3h-.01a.81.81 0 01-.766.6l-.243.021c-.514.034-.591.3-.591.688v.327c0 .384.077.653.591.686l.243.021a.809.809 0 01.766.606h.008a5.632 5.632 0 00.538 1.3h-.006a.809.809 0 01-.114.97l-.157.186c-.339.388-.2.632.069.9l.225.226c.272.272.516.408.9.067l.187-.155a.808.808 0 01.969-.115 5.593 5.593 0 001.3.541.809.809 0 01.6.767l.022.242c.034.515.3.591.687.591h.329c.386 0 .653-.077.687-.591l.022-.242a.822.822 0 01.535-.746 5.564 5.564 0 001.43-.591.818.818 0 01.914.144l.186.156c.388.34.632.2.9-.068l.225-.225c.272-.272.408-.516.067-.9l-.155-.186a.818.818 0 01-.146-.911 5.609 5.609 0 00.608-1.471.826.826 0 01.73-.5l.242-.022c.514-.034.59-.3.59-.686v-.313c0-.385-.076-.653-.59-.688"
      fillRule="evenodd"
    />
  </Wrapper>
)
